iScreenWizard.factory('Certificaat', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('certificaat', params).then(function (response) {
                var certificaten = response.data;
                resolve(certificaten);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('certificaat/'+id).then(function (response) {
                var certificaat = response.data;
                resolve(certificaat);
            }, reject);
        });
    };

    return data;
});